import React from "react";
import MainLayout from "../../components/layout/MainLayout";

// About content component
const AboutContent = () => {
  return (
    <div className="w-full bg-white">
      {/* Header banner with icon */}
      <div className="w-full bg-[#FFF7F3] py-4 px-4 md:px-8 mb-8">
        <div className="max-w-3xl mx-auto flex items-center">
          <div className="mr-4 w-16 h-16 bg-[#C4704B] rounded-lg flex items-center justify-center flex-shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-10 h-10">
              <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z" />
              <path d="M14 15H8v-2h6v2zm0-4H8V9h6v2z" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-800">瓹窿瓹罅既故事</h1>
        </div>
      </div>

      {/* Content area */}
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-6 text-gray-800 font-medium">
            <h2 className="text-xl font-bold">瓹窿瓹罅既故事</h2>

            <p>我地係香港土生土長既80後</p>

            <p>係2018年機緣巧合下，我地成為咗一個菲律賓品牌Paradise既香港代理。</p>

            <p>
              做咗一年，Paradise發展唔算順利，我地搵咗好多唔同既連鎖店、超市、餐廳，透過email,電話,叩門等等唔同方法，希望有機會將呢個新品牌帶入香港。但事實往往係令人沮喪，大部份都係無回覆，有回覆既都係要比一個高昂既上架費。但我地同好多香港人一樣，係唔會咁容易放棄!
            </p>

            <p>
              直到2019年4月我地開始咗「瓹窿瓹罅」呢間Online
              Shop既idea，與其比咁多錢大集團，不如試下自己店自己賣，仲可以聯同更多本地品牌同小代理，一齊瓹窿瓹罅發掘好嘢比大家，建立一間無大集團既香港人店。
            </p>

            <div className="mt-10">
              <h2 className="text-xl font-bold mb-6">瓹窿瓹罅既責任</h2>
              <p>
                作為有責任既企業，除咗發掘優質產品，我哋亦會對地球、對員工、對香港人、對供應商盡責!
                同時亦希望靠「瓹窿瓹罅」既影響力，幫助更多流浪動物
              </p>

              <div className="mt-6 space-y-4">
                <p>由開業已收集物資重用，到2020年更開始有免費上門回收，而回收種類亦越來越多。</p>
                <p>2020年中開始以超低價售賣「唔准嘥嘢」(短期貨)，幫助供應商減少商品浪費</p>
                <p>2021年開始引入網上裸買概念，以最簡約/可重用包裝取代全新包裝</p>
                <p>2022開始「家家浪接浪」計劃，靠大家既力量，環保之餘亦可以幫助更多流浪動物。</p>
                <p>2023正式有第一間24小時便利店「GURU24」係南昌TOWNPLACE</p>
              </div>

              <p className="mt-6">
                不論香港點變，瓹窿瓹罅3大理念「NMIC」「環保」「幫助流浪動物」都會繼續保持初心不變，多謝大家支持💪🏻
              </p>
            </div>

            <div className="mt-10 pt-6 border-t border-gray-200">
              <p className="text-sm text-gray-600">食物製造廠牌照號碼：2997813218</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Main component
const Main = () => {
  return (
    <div className="w-full bg-white">
      <AboutContent />
    </div>
  );
};

// Page component
export default function AboutPage() {
  return (
    <MainLayout title="關於我們 | GuruGuruHK" url="/article/about">
      <Main />
    </MainLayout>
  );
}
